import debug from "debug";

const log = debug("mega-link");

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

class MegaLink {
	constructor(element, options) {
		this.element = element; // li
		this.options = options;

		const scopes = {
			document: document,
			element: this.element
		};

		//	Look for the content element within this element or elsewhere
		const contentSelectorIsId =
			this.options.contentSelector &&
			this.options.contentSelector[0] === "#";

		if (contentSelectorIsId) {
			this.contentSelectorScope = scopes["document"];
		} else {
			this.contentSelectorScope = scopes[
				this.options.contentSelectorScope
			]
				? scopes[this.options.contentSelectorScope]
				: scopes["element"];
		}

		this.link = this.element.querySelector(this.options.linkSelector);
		this.button = this.element.querySelector(this.options.buttonSelector);

		this.content = this.contentSelectorScope.querySelector(
			this.options.contentSelector
		);
		this.collapseWith = this.options.collapsedClass ? "class" : "hidden";
		this.collapsedClass = this.options.collapsedClass;

		this.toggleMethod =
			this.collapseWith === "class"
				? this.toggleWithClass
				: this.toggleWithHidden;

		this.attributeObserver = new MutationObserver(
			this.onAttributeChange.bind(this)
		);

		this.bindDocumentEvents = this.options.closeWithDocumentClick
			? this.bindDocumentClick
			: function() {};

		this.unbindDocumentEvents = this.options.closeWithDocumentClick
			? this.unbindDocumentClick
			: function() {};

		this.init();
		this.watch();
	}

	init() {
		// component enabled - switch link role
		this.link.setAttribute('role', 'button');

		// Determine initial collapse state
		//	if set open option determines init state
		var doCollapse =
			this.options.open !== undefined ? !this.options.open : true;

		this.toggleMethod(doCollapse);
		this.isCollapsed = doCollapse;
	}

	watch() {
		this.link.addEventListener("click", this.handleUnmodifiedClick.bind(this));
		this.link.addEventListener('keydown', this.handleKeyDown.bind(this));
		this.attributeObserver.observe(this.element, { attributes: true });
		if (this.button) {
			this.button.addEventListener("click", this.toggle.bind(this));
		}

		if (this.options.closeOnPageshow === true) {
			window.addEventListener('pageshow', this.handlePageShow.bind(this));
		}
	}

	// Respond to space key
	handleKeyDown(event) {
		if (event.keyCode === 32) {
			event.preventDefault();
			this.toggle();
		}
	}

	//  Only respond to click without key modifier
	handleUnmodifiedClick(event) {
		if (!event.ctrlKey && !event.altKey && !event.metaKey) {
			event.preventDefault();
			this.toggle();
		}
	}

	toggleWithHidden(doCollapse) {
		this.link.setAttribute("aria-expanded", !doCollapse);

		if (!this.content) {
			return false;
		}
		this.content.hidden = doCollapse;
	}

	toggleWithClass(doCollapse) {
		this.link.setAttribute("aria-expanded", !doCollapse);

		if (!this.content) {
			return false;
		}
		if (doCollapse) {
			this.content.classList.add(this.collapsedClass);
		} else {
			this.content.classList.remove(this.collapsedClass);
		}
	}

	// button click handler
	toggle() {
		if (!this.options.selfClosing && !this.isCollapsed) {
			return false;
		}

		const handler = this.isCollapsed
			? this.open.bind(this)
			: this.close.bind(this);
		handler();
	}

	open() {
		this.toggleMethod(false);
		this.isCollapsed = false;
		this.element.dataset.megaLinkOpen = true;
		this.bindDocumentEvents();

		const openedEvent = new CustomEvent(this.options.onUncollapse, {
			bubbles: true,
			cancelable: true,
			// detail: {}
		});

		this.element.dispatchEvent(openedEvent);
	}

	close() {
		this.toggleMethod(true);
		this.isCollapsed = true;
		this.element.dataset.megaLinkOpen = false;
		this.unbindDocumentEvents();

		const closedEvent = new CustomEvent(this.options.onCollapse, {
			bubbles: true,
			cancelable: true
		});

		this.element.dispatchEvent(closedEvent);
	}

	bindDocumentClick() {
		document.addEventListener("click", this.onDocumentClick.bind(this));
	}

	unbindDocumentClick() {
		document.removeEventListener("click", this.onDocumentClick);
	}

	onDocumentClick(event) {
		const clickTarget = event.target;

		// clicked within element (li)
		if (clickTarget === this.element || this.element.contains(clickTarget)) {
			log("clicked within element");
			return false;
		}

		// clicked this.button
		if (this.button) {
			if (clickTarget === this.button || this.button.contains(clickTarget)) {
				log("clicked button");
				return false;
			}
		}

		// clicked this.link
		if (clickTarget === this.link || this.link.contains(clickTarget)) {
			log("clicked link");
			return false;
		}

		this.close();
	}

	handlePageShow(event){
		if (event.persisted && this.isCollapsed === false) {
			this.close();
		}
	}

	onAttributeChange(mutationList, observer) {
		mutationList
			.filter(mutation => {
				return (
					mutation.type === "attributes" &&
					mutation.attributeName.startsWith("data-mega-link-open")
				);
			})
			.forEach(this.onOpenChanged.bind(this));
	}

	onOpenChanged(mutation) {
		const doCollapse = !getJSONValue(this.element.dataset.megaLinkOpen);
		if (this.isCollapsed !== doCollapse) {
			this.toggleMethod(doCollapse);
			this.isCollapsed = doCollapse;
		}
	}
}

MegaLink.DEFAULTS = {
	selfClosing: true,
	onCollapse: 'collapsibleClosed',
	onUncollapse: 'collapsibleOpened'
};

export default MegaLink;



// WEBPACK FOOTER //
// ./client/src/core/plugins/jquery__mega-link/mega-link.js